import t from "../locales";

export default function Header() {
  return <header className="header">{t("general.edubox.title")}</header>;
}
